import React from "react";
import { SupplierAutocomplete } from "./SupplierAutocomplete";

/**
 * Backwards-compatible wrapper around <SupplierAutocomplete>.
 *
 * Historically SupplierPicker exposed a simple <select> of existing suppliers
 * with a fallback "otherSupplier" free-text input. Callers pass:
 *   { value: string, onChange: (name: string) => void, testId?: string }
 *
 * We now delegate to <SupplierAutocomplete>, which offers live search plus
 * an inline "+ Create supplier ..." button that saves brand-new suppliers to
 * the catalog on the fly (deduplicated server-side). The wrapper adapts the
 * richer `{ name, id }` callback back to the old string-only API so every
 * existing consumer (Purchasing, Materials, SplitReceipt, TicketPurchaseNotes,
 * MaterialRequestsTab, etc.) inherits the new UX with zero refactoring.
 */
export const SupplierPicker = ({ value, onChange, testId }) => (
  <SupplierAutocomplete
    value={value}
    onChange={({ name }) => onChange(name)}
    testId={testId}
  />
);

export default SupplierPicker;
